<div class="d-flex justify-content-center mt-5 text-white text-center" >
    <div class="mt-5">
        @if (loading) {
            <div class="spinner-grow text-light" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <h6>Authenticating...</h6>
        } @else {
            <div><h6>Your session has expired, Please login with your pin</h6></div>
        }
    </div>
</div>